import styled, { css } from 'styled-components'
import { Tag } from '@pinchenterprisesnpm/friday-ui'

export const Heading = styled.h4`
  color: ${props => props.color};
`

export const Paragraph = styled.p`
  color: ${props => props.theme.palette.white};
`

export const BadgesCellStyle = styled.div<{
  details: boolean
  claim: boolean
  hire: boolean
  multiday: string
}>`
  display: flex;
  align-items: end;
  padding: 0px !important;
  margin-top: 2px;
  position: static;
  top: auto;
  right: auto;

  @media only screen and (max-width: 380px) and (min-width: ${props =>
      `${props.theme.breakpoints.sm}px`}) {
    ${props =>
      props.details &&
      (props.claim === true || props.hire === true || props.multiday === '1') &&
      css`
        position: absolute;
        top: -5px;
        right: ${props => props.theme.mp.xs};
      `}
  }

  > span:last-child {
    margin-right: 0px;
  }
`

export const BadgeItem = styled(Tag)<{
  color?: string
  border?: string
  background?: string
}>`
  color: ${({ color, theme: { palette } }) =>
    color ? palette[color as keyof typeof palette] : 'transparent'};
  border: 1px solid
    ${({ border, color, theme: { palette } }) =>
      border && color ? palette[color as keyof typeof palette] : 'transparent'};
  border-radius: ${({ theme: { mp } }) => mp.sm};
  padding: 6px 6px 4px 6px;
  font-weight: ${({
    theme: {
      font: { weights },
    },
  }) => weights.regular};
  text-transform: capitalize;
  background: ${({ background, theme: { palette } }) =>
    background ? background : 'transparent'};
  margin: ${({ background, theme: { mp } }) => `0px ${mp.xs} 0px 0px`};
  @media only screen and (min-width: ${props =>
      `${props.theme.breakpoints.md}px`}) {
    padding: 3px 8px;
  }
`
